import { Component } from '@angular/core';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';

@Component({
  selector: 'app-task-manager-button',
  templateUrl: './task-manager-button.component.html',
  styleUrls: ['./task-manager-button.component.scss'],
})
export class TaskManagerButtonComponent {
  taskManagerIsOpen = false;

  constructor(public praticaProgressService: PraticaProgressService) {}

  onClose() {
    this.taskManagerIsOpen = false;
  }

  toggleTaskManager() {
    this.taskManagerIsOpen = !this.taskManagerIsOpen;
  }
}
